<template>
  <div v-if="data !== null">
    <Top />
    <br />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <!-- Rökning -->
        <div class="col-md-6" v-if="fieldId === '10112900'">
          <p ref="scrQuestion" v-html="data.screening.screeningSmoking"></p>
        </div>
        <!-- Hypertoni -->
        <div class="col-md-6" v-if="fieldId === '10112959'">
          <p ref="scrQuestion" v-html="data.screening.screeningHypertension"></p>
        </div>
        <!-- Diabetes typ 1 -->
        <div class="col-md-6" v-if="fieldId === '10112960'">
          <p ref="scrQuestion" v-html="data.screening.screeningDiabetesTypeOne"></p>
        </div>
        <!-- Diabetes typ 2 -->
        <div class="col-md-6" v-if="fieldId === '10112961'">
          <p ref="scrQuestion" v-html="data.screening.screeningDiabetesTypeTwo"></p>
        </div>
        <!-- Hjärtinfarkt/åderförkalkning -->
        <div class="col-md-8" v-if="fieldId === '10113022'">
          <p ref="scrQuestion" v-html="data.screening.screeningArteriosclerosis"></p>
        </div>
        <!-- Stroke -->
        <div class="col-md-6" v-if="fieldId === '10113032'">
          <p ref="scrQuestion" v-html="data.screening.screeningStroke"></p>
        </div>
        <!-- Claudicatio/fönstertittarsjuka -->
        <div class="col-md-8" v-if="fieldId === '10113155'">
          <p ref="scrQuestion" v-html="data.screening.screeningPeephole"></p>
        </div>
        <!-- Dela journaluppgifter -->
        <div class="col-md-6" v-if="fieldId === '10113375'">
          <p ref="scrQuestion" v-html="data.welcomepage.consentShareJournals"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div :class="['10113155', '10113022'].includes(fieldId) ? 'col-md-8' : 'col-md-6'">
          <!-- Hjärtinfarkt, stroke och/eller claudicatio -->
          <button class="btn btn-success btn-lg btn-block" @click="verifyAnswer('Ja')"
            v-if="(['10113022', '10113032', '10113155'].includes(fieldId) && yes_age && age !== 0) && !yes_share">
            Nästa
          </button>
          <div class="clearfix"></div>
          <label class="pull-left text-left" v-if="['10113022', '10113032', '10113155'].includes(fieldId) && yes_age">
            Vid vilken ålder drabbades du/fick det bekräftat första gången?
          </label>
          <select class="form-control m-w-220" v-model="age"
            v-if="['10113022', '10113032', '10113155'].includes(fieldId) && yes_age">
            <option :value="0">Välj ålder</option>
            <option v-for="age in ages0to100" :value="age" :key="age">{{ age }}</option>
          </select>
          <div class="clearfix"></div>
          <!-- Dela dina journaluppgifter -->
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="yes_share = true"
          v-if="fieldId === '10113375'"
          :class="(previousanswer === 'Ja' || yes_share) ? 'previous-answer': ''">Ja</button>
          <!-- Hjärtinfarkt, stroke och/eller claudicatio -->
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="yes_age = true"
          v-if="['10113022', '10113032', '10113155'].includes(fieldId)"
          :class="(previousanswer === 'Ja' || yes_age) ? 'previous-answer': ''">Ja</button>
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="verifyAnswer('Ja')"
          v-if="!['10113022', '10113032', '10113155', '10113375'].includes(fieldId)"
          :class="previousanswer === 'Ja' ? 'previous-answer': ''">Ja</button>
          <div class="clearfix"></div>
          <!-- Rökning -->
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="verifyAnswer('Nej (slutat röka)')"
          v-if="fieldId === '10112900'"
          :class="(previousanswer === 'Nej (slutat röka)' && !yes_age) ? 'previous-answer': ''">Nej (slutat röka)</button>
          <!-- Hjärtinfarkt, stroke och/eller claudicatio -->
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="confirmAnswer()"
          v-if="['10113022', '10113032', '10113155'].includes(fieldId)"
          :class="(previousanswer === 'Nej' && !yes_age) ? 'previous-answer': ''">Nej</button>
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="verifyAnswer('Nej')"
          v-if="!['10113022', '10113032', '10113155'].includes(fieldId)"
          :class="previousanswer === 'Nej' ? 'previous-answer': ''">Nej</button>
          <div class="clearfix"></div>
          <!-- Ange vårdinrättning -->
          <div v-if="fieldId === '10113375' && yes_share">
            <label class="pull-left text-left" for="careFacility">
              Du kan ange vårdinrättning (ex. sjukhus eller vårdcentral) där du tidigare mätt dina blodfettvärden.
            </label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon3">(Valfritt)</span>
              </div>
              <input type="text" v-model="careFacility" class="form-control" id="careFacility">
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-success btn-lg btn-block" @click="verifyAnswer('Ja')"
            v-if="yes_share">Nästa</button>
          <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="goBack()">&#8592; Tillbaka</button>
          <div class="clearfix"></div>
          <small class="pull-left">Välj ett alternativ för att gå vidare.</small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'

export default {
  name: 'screening',
  props: ['fieldId'],
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      previousanswer: '',
      question: null,
      age: 0,
      careFacility: null,
      yes_age: false,
      yes_share: false
    }
  },
  methods: {
    confirmAnswer () {
      const r = confirm('Är du säker på ditt svar och vill gå vidare?')
      if (r) {
        this.age = null
        this.yes_age = false
        this.verifyAnswer('Nej')
      }
    },
    goBack () {
      this.$router.go(-1)
      this.getPreviousAnswer()
    },
    getPreviousAnswer () {
      let loader = this.$loading.show()
      axios._get(config.screeningAnswerUri).then(response => {
        const result = response.data.answers.find(answ => answ.fieldId === parseInt(this.fieldId))
        if (result && result.length !== 0) {
          const parsedResult = JSON.parse(result.answer)
          this.previousanswer = parsedResult.answer
          this.age = parsedResult.age !== null ? parsedResult.age : 0
          this.yes_age = parsedResult.answer === 'Ja'
          loader.hide()
        } else {
          this.previousanswer = ''
          this.age = 0
          this.yes_age = false
          loader.hide()
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Request went bad to screeninganswers: ' + error)
          loader.hide()
        }
      })
    },
    verifyAnswer (_answer) {
      if (_answer !== null) {
        let loader = this.$loading.show()
        const answer = {
          question: this.$refs.scrQuestion.firstChild.innerText,
          answer: _answer,
          age: this.age !== 0 ? this.age : null,
          carefacility: this.careFacility !== null ? this.careFacility : null,
          timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
        }
        axios.postScreeningAnswer(config.screeningAnswerUri, JSON.stringify(answer), parseInt(this.fieldId)).then((response) => {
          if (response.status === 200) {
            loader.hide()
            this.decideRouteByFieldId()
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    },
    decideRouteByFieldId () {
      switch (this.fieldId) {
        // screeningsmoking
        case '10112900':
          this.$router.push({
            name: 'screening',
            params: { fieldId: '10112959' }
          })
          this.getPreviousAnswer()
          break
        // screeninghypertension
        case '10112959':
          this.$router.push({
            name: 'screening',
            params: { fieldId: '10112960' }
          })
          this.getPreviousAnswer()
          break
        // screeningdiabetestype1
        case '10112960':
          this.$router.push({
            name: 'screening',
            params: { fieldId: '10112961' }
          })
          this.getPreviousAnswer()
          break
        // screeningdiabetestype2
        case '10112961':
          this.$router.push({
            name: 'screening',
            params: { fieldId: '10113022' }
          })
          this.getPreviousAnswer()
          break
        // screeningarteriosclerosis
        case '10113022':
          this.$router.push({
            name: 'screening',
            params: { fieldId: '10113032' }
          })
          this.getPreviousAnswer()
          break
        // screeningstroke
        case '10113032':
          this.$router.push({
            name: 'screening',
            params: { fieldId: '10113155' }
          })
          this.getPreviousAnswer()
          break
        // screeningpeephole
        case '10113155':
          window.location.href = window.location.origin.concat('/screeningmed')
          break
        // consentjournals
        case '10113375':
          window.location.href = window.location.origin.concat('/createremittance')
          break
        default:
      }
    }
  },
  beforeMount () {
    this.getPreviousAnswer()
  },
  computed: {
    ages0to100 () {
      return Array.from({length: 101}, (_, i) => i)
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            screeningSmoking
            screeningHypertension
            screeningDiabetesTypeOne
            screeningDiabetesTypeTwo
            screeningArteriosclerosis
            screeningStroke
            screeningPeephole
          }
          welcomepage {
            consentShareJournals
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 110px;
  margin-bottom: 50px;
  min-height: 60vh;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.pull-left {
  float: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Screening.vue